import React, { useState } from "react";
import { supabase } from "../supabaseClient";

function LoginPage1({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");

    const { data, error } = await supabase
      .from("employee")
      .select("*")
      .eq("username", username)
      .single();

    if (error || !data || !data.is_active) {
      setErr("Invalid username or password, or this account is inactive");
      return;
    }

    if (data.password_hash !== password) {
      setErr("Invalid username or password");
      return;
    }

    onLogin({
      id: data.id,
      name: data.name,
      username: data.username,
      job_title: data.job_title,
      showroom_id: data.showroom_id,
      phone: data.phone,
      is_active: data.is_active,
      role: data.role || data.job_title || "employee",
      company_codes: data.company_codes,
    });
  }

  return (
    <div
      dir="ltr"
      className="auth-screen"
    >
      <form
        onSubmit={handleSubmit}
        className="auth-card"
      >
        <p className="auth-brand">Abbas Halim Group</p>
        <h2>
          Sign in
        </h2>
        <p className="auth-subtitle">Welcome back to your company workspace.</p>
        <div style={{ marginBottom: 18 }}>
          <label
            style={{ display: "block", color: "var(--accent, #514536)", marginBottom: 6 }}
            htmlFor="username"
          >
            Username
          </label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: 6,
              border: "1px solid #d2cbc1",
              fontSize: 15,
              textAlign: "left",
            }}
            placeholder="Username"
            autoFocus
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label
            style={{ display: "block", color: "var(--accent, #514536)", marginBottom: 6 }}
            htmlFor="password"
          >
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: 6,
              border: "1px solid #d2cbc1",
              fontSize: 15,
              textAlign: "left",
            }}
            placeholder="Password"
          />
        </div>
        {err && (
          <div
            style={{
              color: "#514536",
              marginBottom: 12,
              fontWeight: "bold",
              fontSize: 15,
              textAlign: "center",
            }}
          >
            {err}
          </div>
        )}
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: 6,
            background: "var(--accent, #514536)",
            color: "#faf8f4",
            border: "none",
            fontWeight: "bold",
            fontSize: 16,
            marginTop: 6,
            cursor: "pointer",
          }}
        >
          Sign in
        </button>
      </form>
    </div>
  );
}

export default LoginPage1;
